import {gql} from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_NATIONALSTANDING = gql`
  query getRankings {
    getRankings {
      uid
      ranking
      supports {
        tournamentData {
          name
          startDate
          finishDate
          address {
            city
            state
            country
          }
          conditions {
            gender
            numberOfRounds
            tournamentType
            modalityGame
            pointLimit
            tournamentCategory
          }
        }
        stats {
          place
          matchesWon
          matchesLose
          matchDifference
          pointsAgainst
          pointsInFavor
          pointDifference
        }
        rankingObtained
      }
    }
  }
`;
